"use strict";
export const NewPosition = () => {
  return <div><h1>New Position</h1></div>;
};
